import angular from 'angular';
import lmiLenderMortgage from './lmiLenderMortgage';
import lmiLenderMortgageCtrl from './lmiLenderMortgageCtrl';

export default angular
  .module('components.lmiLenderMortgage', [])
  .controller('LmiLenderMortgageCtrl', lmiLenderMortgageCtrl)
  .component('lmiLenderMortgage', lmiLenderMortgage).name;
